<template>
    <xm-drawer :title="msg('批量更新')" :width="isMinScreen?'100%':'30%'" :content-width="'100%'"
    :visible.sync="visible">
        <div class="xform">
            <el-row :gutter="10" type="flex" justify="space-between" align="center" >
                <el-col :span="9">
                    <el-select v-model="type" size="mini" clearable :placeholder="msg('请选择')" @change="getSelectes">
                        <template v-for="(t, idx) in types">
                            <el-option v-if="hasPermission(t.auth)" :label="t.label" :value="idx" :key="idx"></el-option>
                        </template>
                    </el-select>
                </el-col>
                <el-col :xs="15">
                    <div style="display:flex;">
                        <div style="white-space:nowrap;">{{msg('批量填充')}}： </div>
                        <el-autocomplete v-if="type === 2" size="mini"
                            v-model="iptLabel"
                            :fetch-suggestions="querySearch"
                            placeholder="输入要填充的值"
                            :trigger-on-focus="false"
                            @select="handleSelect"
                        ></el-autocomplete>
                        <el-select v-else-if="type ===1" placeholder="请选择仓位" v-model="iptValue" clearable  size="small">
                                <el-option
                                v-for="item in stores"
                                :key="item.id" 
                                :label="item.name"
                                :value="item.id"> 
                            </el-option>
                        </el-select>
                        <el-input v-else style="max-width:200px;"
                            size="mini" :placeholder="msg('输入要填充的值')" v-model="iptValue" >
                        </el-input>
                        <!-- <el-button size="mini" icon="el-icon-check" @click="fillValue"></el-button> -->
                    </div>
                </el-col>
            </el-row>
            <div style="display:flex;margin-top:20px;margin-bottom:10px;align-items:center;justify-content:center;">
                <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定更新')}}</span></el-button>
                <el-checkbox style="margin-left:10px;" v-model="isShowTable">查看列表</el-checkbox>
            </div>
            <div class="table-wrap" v-if="isShowTable">
                <vxe-table :data="inventoryIns"
                        export-config stripe
                        resizable border="full"
                        highlight-current-row highlight-hover-column highlight-current-column
                        show-overflow show-header-overflow 
                        :height="docHeight" 
                        :scroll-y="{gt: 50}"
                        style="width: 100%" ref="dataTable" >
                    <vxe-table-column field="id" :title="msg('ID')" width="80" sortable></vxe-table-column>
                    <vxe-table-column field="key" :title="msg('订单编号')" min-width="120" :show-overflow-tooltip="true"></vxe-table-column>
                    <vxe-table-column field="value" :title="msg('数据')" min-width="150" >
                        <template v-slot="{ row }">
                            <el-autocomplete v-if="type == 2" size="mini"
                                v-model="row.label"
                                :fetch-suggestions="querySearch"
                                placeholder="输入要填充的值"
                                :trigger-on-focus="false"
                                @select="(item) => handleSelect(item, row)"
                            ></el-autocomplete>
                            <el-select v-else-if="type == 1" placeholder="请选择仓位" v-model="row.value" clearable  size="small">
                                <el-option
                                    v-for="item in stores"
                                    :key="item.id" 
                                    :label="item.name"
                                    :value="item.id"> 
                                </el-option>
                            </el-select>
                            <el-input v-else
                                size="mini" :placeholder="msg('输入要填充的值')" v-model="row.value"  >
                            </el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="result"  min-width="200" header-align="right">
                        <!-- <template slot="header">
                            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定更新')}}</span></el-button>
                        </template> -->
                    </vxe-table-column>
                </vxe-table>
            </div>
        </div>
    </xm-drawer>
</template>

<script>
import XmDrawer from "../../components/XmDrawer.vue";
export default {
    name: "InventoryInBatchUpdate",
    components:{
        XmDrawer: XmDrawer
    },
    data(){
        return {
            visible: false,
            type: null,
            types: [
                {label: this.msg('备注'), auth: 'inventoryIn:update'},       //0
                {label: this.msg('仓库'), auth: 'inventoryIn:update'},    //1
                {label: this.msg('归属人'), auth: 'inventoryIn:update'},  //2
            ],
            stores: [],

            iptValue: null,
            iptLabel: null,
            inventoryIns: null, //要更新的数据
            isShowTable: false,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
    },
    methods: {
        showDrawer(inventoryIns, stores){
            if(!this.stores || this.stores.length==0){
                if(stores && stores.length>0){
                    this.getStores();
                }else{
                    this.stores = stores;
                }
            }
            this.iptLabel = null;
            this.iptValue = null;
            this.type = null;
            this.inventoryIns = inventoryIns;
            this.visible = true;
        },
        getSelectes(){
            this.iptValue = null;
            this.iptLabel = null;

            this.inventoryIns.forEach(d => {
                d.value = null;
                d.label = null;
                d.result = null;
            });
        },
        getStores(){
            this.$axios.post(this.$kit.api.store.listUsed, 
                {}
            ).then( (result) => {
                if(result.status){
                    let data = result.data;
                    data.splice(0, 0, {id: 0, name: '默认仓库'});
                    this.stores = data;
                }
            });
        },
        handleSelect(item, row) { //获取选中值
            if(row){
                row.value = item.id,
                row.label = item.value
            }else{
                this.iptValue = item.id;
                this.iptLable = item.value;
            }
        },
        querySearch(queryString, cbFn){  //搜索用户
            this.$axios.get(this.$kit.api.user.search
                +"?name="+encodeURIComponent(queryString)+"&type=1"
            ).then((result) => {
                if(result.status){
                    let users =[];
                    result.data.forEach(e => {
                        users.push({
                            id: e.id,
                            value: e.value
                        });
                    });
                    cbFn(users);
                }
            });
        },
        onSubmit: function(){
            // this.datas.forEach(d => {
            //     d.label = this.iptLabel;
            //     d.value = this.iptValue;
            // })

            let ds = {};
            this.inventoryIns.forEach(inv => {
                ds[inv.id] = inv.value || this.iptValue
            });

            var _this = this;
            this.$axios.post(this.$kit.api.inventoryIn.batchUpdate
                +"?t="+this.type || 0, ds
            ).then((result) => {
                this.$message(result.msg || _this.msg('更新失败'));

                if(result.status){
                    // _this.$message(result.msg || _this.msg('更新成功'));
                    let map = result.data;
                    this.inventoryIns.forEach(inv => {
                        inv.result = map[inv.id];
                    });
                }
            });

        }
    }

}
</script>

<style lang="scss" scoped>
.xform{
    box-sizing: border-box;
}
.xctrl{
    text-align:center;
    padding:15px;
    width:100%;
}

</style>